import React from 'react';

import { Breadcrumbs } from '@mui/material';

import { BreadcrumbsSeparatorIcon } from 'components/common/Icons/common/BreadcrumbsSeparatorIcon/BreadcrumbsSeparatorIcon';

export const HeaderBreadcrumbs = ({ children }) => {
    return <Breadcrumbs separator={<BreadcrumbsSeparatorIcon />}>{children}</Breadcrumbs>;
};
